import { useEffect, useState } from 'react';
import { axiosInstance } from 'src/services/axiosSetup';

interface useFetchUsersReturn<T> {
    data: T | null;
    isError: boolean;
    isLoading: boolean;
    message: string;
}

function useFetchApi<T = unknown>(url: string): useFetchUsersReturn<T> {
    const [data, setData] = useState<T | null>(null);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!url) return;

        let isMounted = true;
        setIsLoading(true);
        setIsError(false);
        setMessage('');

        axiosInstance.get(url)
            .then(async (d: any) => setData(d.data?.data))
            .catch((error) => {
                if (isMounted) {
                    setIsError(true);
                    setMessage(error.message || 'Something went wrong');
                    setIsLoading(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [url]);

    return { data, isError, isLoading, message };
}

export default useFetchApi;